module.exports = __webpack_public_path__ + "img/banner.c2db8943.png";